import { render, staticRenderFns } from "./kra-tax.vue?vue&type=template&id=caa3f418&scoped=true&"
import script from "./kra-tax.vue?vue&type=script&lang=js&"
export * from "./kra-tax.vue?vue&type=script&lang=js&"
import style0 from "./kra-tax.vue?vue&type=style&index=0&id=caa3f418&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa3f418",
  null
  
)

export default component.exports